import React from 'react';
import { Image, ImageProps } from '@chakra-ui/react';
import { styles } from './styles/Logo.styles';

export default function Logo(props: ImageProps) {
  return <Image {...styles.img} {...props} />;
}
